import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import { transformFiltersToQuery } from './utils/transformFilterToQuery';

export const integrationLoglice = createSlice({
    name: 'integrationLog',
    initialState: {
        integrationLogs: [],
        error: null,
        count: 0,
        currentPage: 1,
        totalPages: 1,
        total: 0,
        offset: 0,
        limit: 10,
        pending: false,
    },
    reducers: {
        start: (state) => {
            state.pending = true;
        },
        stop: (state) => {
            state.pending = false;
        },
        setIntegrationLogs: (state, action) => {
            state.pending = false;
            const {
                items,
                total,
                count,
                currentPage,
                totalPages,
                offset = state.offset,
            } = action.payload;
            state.count = count;
            state.total = total;
            state.integrationLogs = items;
            state.offset = offset;
            state.currentPage = currentPage;
            state.totalPages = totalPages;
        },
        setError: (state, action) => {
            state.pending = false;
            state.error = action.payload;
        },
    },
});

export const { start, stop, setIntegrationLogs, setError } = integrationLoglice.actions;

export const getIntegrationLogs = (state) => state.integrationLog.integrationLogs;
export const getIntegrationLogsPending = (state) => state.integrationLog.pending;
export const getIntegrationLogsError = (state) => state.integrationLog.error;
export const getIntegrationLogsTotal = (state) => state.integrationLog.total;
export const getIntegrationLogsCurrentPage = (state) => state.integrationLog.currentPage;
export const getIntegrationLogsTotalPages = (state) => state.integrationLog.totalPages;

export const fetchIntegrationLogsAction =
    ({ integrationId, queryParams = {}, onSuccess, onFailure } = {}) =>
    async (dispatch, getState) => {
        const { limit: stateLimit } = getState().integrationLog;
        const limit = Number.isFinite(+queryParams.limit) ? +queryParams.limit : stateLimit;
        const page = Number(queryParams.page);
        const offset = Number.isFinite(+queryParams.offset)
            ? +queryParams.offset
            : Number.isInteger(page) && page > 0
              ? (page - 1) * limit
              : 0;
        try {
            if (offset === 0) {
                dispatch(
                    setIntegrationLogs({
                        items: [],
                        total: 0,
                        count: 0,
                        offset: 0,
                        limit,
                    }),
                );
            }
            const query = transformFiltersToQuery({ ...queryParams, limit, offset });
            dispatch(start());
            api.get(`integrations/history/${integrationId}${query}`)
                .then((response) => {
                    dispatch(
                        setIntegrationLogs({
                            ...response.data,
                            offset,
                            limit,
                        }),
                    );
                    if (onSuccess) {
                        onSuccess(response.data);
                    }
                    return response;
                })
                .catch((error) => {
                    dispatch(setError(error));
                    if (onFailure) {
                        onFailure(error);
                    }
                });
        } catch (e) {
            dispatch(stop());
            return console.error('error', e);
        }
    };

export const replayIntegrationRequestAction =
    ({ integrationId, trackingId, onSuccess, onFailure }) =>
    async () => {
        try {
            api.post(`integrations/${integrationId}/history/${trackingId}/replay`)
                .then((response) => {
                    if (onSuccess) {
                        onSuccess(response.data);
                    }
                    return response;
                })
                .catch((error) => {
                    if (onFailure) {
                        onFailure(error);
                    }
                });
        } catch (error) {
            console.error('Error replaying integration request.', error);
            throw error;
        }
    };

export default integrationLoglice.reducer;
